import { PUNISHMENT_TYPE } from './constants';

function isBanType(punishmentTypeDescription: string): boolean {
  const isValidPunishmentType = Object.values(PUNISHMENT_TYPE).includes(
    punishmentTypeDescription as PUNISHMENT_TYPE
  );
  return isValidPunishmentType && punishmentTypeDescription.startsWith('Ban');
}

export default isBanType;
